import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { v4 as uuidv4 } from 'uuid';
import { Geolocation } from '../../../../models/geolocation.model';

@Component({
  selector: 'app-view-location',
  standalone: true,
  imports: [GoogleMapsModule],
  templateUrl: './view-location.component.html',
  styleUrls: ['./view-location.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewLocationComponent implements OnChanges {
  @Input() location?: Geolocation;
  @Input() height: string = '300px';

  private cdr = inject(ChangeDetectorRef);

  uuid = uuidv4();

  options: google.maps.MapOptions = {
    mapId: 'b45898a1f3fbad8919f6191f',
    mapTypeId: 'roadmap',
    zoomControl: true,
    // center: { lat: 25.2697, lng: 55.3095 },
    scrollwheel: true,
    disableDoubleClickZoom: false,
    zoom: 8,
    fullscreenControl: false,
    streetViewControl: false,
  };

  getChurchMarkerContent(): HTMLElement | null {
    if (typeof document !== 'undefined') {
      const img = document.createElement('img');
      img.src = 'assets/markers/marker_church.png';
      img.style.width = '28px';
      img.style.height = '34px';
      return img;
    }
    return null;
  }

  markerOptions: google.maps.marker.AdvancedMarkerElementOptions = {
    gmpDraggable: false,
  };
  markerContent: HTMLElement | null = null;
  markerPosition: google.maps.LatLngLiteral | null;

  constructor() {
    this.markerContent = this.getChurchMarkerContent();
    this.options = {
      ...this.options,
      center: {
        lat: this.location?.position?.latitude ?? 25.2697,
        lng: this.location?.position?.longitude ?? 55.3095,
      },
    };
    if (this.location?.position) {
      this.markerPosition = {
        lat: this.location?.position?.latitude,
        lng: this.location?.position?.longitude,
      };
    } else {
      this.markerPosition = null;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.location) {
      if (!this.markerContent) {
        this.markerContent = this.getChurchMarkerContent();
      }
      this.options = {
        ...this.options,
        center: {
          lat: this.location?.position?.latitude ?? 25.2697,
          lng: this.location?.position?.longitude ?? 55.3095,
        },
      };
      if (this.location?.position) {
        this.markerPosition = {
          ...this.markerPosition,
          lat: this.location?.position?.latitude,
          lng: this.location?.position?.longitude,
        };
      }
      this.cdr.detectChanges();
    }
  }
}
